import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { CalibrationId } from 'services/equipmentSets/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import PrintSprayWorksheetCalibrationTableHeader from './components/PrintSprayWorksheetCalibrationTableHeader';
import PrintSprayWorksheetCalibrationTableRow from './components/PrintSprayWorksheetCalibrationTableRow';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

type Props = OwnProps;

export default class PrintSprayWorksheetCalibrationTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { calibrationId, pageIndex } = this.props;

        return (
            <ResponsiveTable>
                <Table basic="very" className="basic-table" unstackable>
                    <PrintSprayWorksheetCalibrationTableHeader />
                    <TableBody>
                        <PrintSprayWorksheetCalibrationTableRow
                            calibrationId={calibrationId}
                            pageIndex={pageIndex}
                        />
                    </TableBody>
                </Table>
            </ResponsiveTable>
        );
    }
}
